import React from 'react'
import { Outlet } from 'react-router-dom'
import Sidebar from '../components/Sidebar/Sidebar'
import SimpleToolbar from '../components/Toolbar/SimpleToolbar'
import './Layout.css'

const Layout = ({ isSidebarCollapsed, toggleSidebar }) => {
  return (
    <div className='app-container'>
      <Sidebar
        collapsed={isSidebarCollapsed}
        onToggleCollapse={toggleSidebar}
      />
      <div className={`main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <SimpleToolbar />
        <div className='page-content'>
          <Outlet />
        </div>
      </div>
    </div>
  )
}

export default Layout
